export default __webpack_public_path__ + "static/media/Group1171.57a5f9d2.svg";